var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabletIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.95,
    height: 92.95,
    viewBox: "0 0 92.95 92.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #cee5dd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "infos_icons",
    "data-name": "infos icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabletIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 92.95,
    height: 92.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.4,22.38H18.56A2.52,2.52,0,0,0,16,24.9V89.43A2.52,2.52,0,0,0,18.56,92H74.4a2.51,2.51,0,0,0,2.51-2.52V24.9A2.51,2.51,0,0,0,74.4,22.38Zm-24,62.71a3.94,3.94,0,0,1-2.14,2.14,4.4,4.4,0,0,1-5.81-5.81,4,4,0,0,1,2.15-2.14A4.39,4.39,0,0,1,50.45,85.09Zm21.66-9.83H20.84V27.05H72.11Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletIcon);
export default __webpack_public_path__ + "static/media/tabletIcon.da75443ba5dc69f7ac61d3928bec8d56.svg";
export { ForwardRef as ReactComponent };